import { Typography } from 'components/_common/Typography';
import React from 'react';
import { formatNumberOfCasesVerbose } from 'utils/stringFormattingHelpers';

type CaseCountSummaryProps = {
  reportedCases: number;
  parentLocationReportedCases: number;
  isInherited?: boolean;
  locationName: string;
  parentLocationName: string;
  diseaseName: string;
};

const CaseCountSummary: React.FC<CaseCountSummaryProps> = ({
  reportedCases,
  parentLocationReportedCases,
  isInherited = false,
  locationName,
  parentLocationName,
  diseaseName,
}) => {
  const cases = isInherited ? parentLocationReportedCases : reportedCases;
  const casesLocationName = isInherited ? parentLocationName : locationName;
  if (cases && cases > 0) {
    return (
      <div data-testid="case-count-summary">
        <Typography variant="subtitle1" inline>
          {formatNumberOfCasesVerbose(cases, 'reported case')}
        </Typography>{' '}
        of {diseaseName} in {casesLocationName} in the last 60 days
      </div>
    );
  }

  return null;
};

export default CaseCountSummary;
